import './task-list.styles.scss';

const TaskList = ({ tasks, handleDelete }) => {
  return (
    <div className='task-list-container'>
      <ul>
        {tasks.map((task) => {
          console.log(task);
          if (task.title !== null) {
            return (
              <li key={task.key}>
                <div className='checkbox-container'>
                  <label className='checkbox-control'>
                    <input className='checkmark' type='checkbox' />
                  </label>
                  {task.title.charAt(0).toUpperCase() + task.title.slice(1)}
                </div>
                <button onClick={() => handleDelete(task.id)}>Delete</button>{' '}
              </li>
            );
          }
        })}
      </ul>
    </div>
  );
};

export default TaskList;
